import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/u891211986/domains/rsvpsure.com/hbuilds/source/repository/src/app/components/InvitationCard.tsx");
